import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FilterDto } from '../../../types/FilterDto';
import { useState } from 'react';


interface SelectFilterProps {
    filter: FilterDto;
    values: string[];
    onSelectChange: (name: string, values: string[], description: string) => void;
}
export default function SelectFilter({ filter, values,  onSelectChange }: SelectFilterProps) {
   const { t } = useTranslation(['dashboard']);
    const [selected, setSelected] = useState<string>('');

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        //setSelected(selectedValue);
        const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
        onSelectChange(filter.name, selectedOptions, filter.description);
    };

  return (
    <Form.Group controlId={`form${filter.name}Select`}>
      <Form.Label>{filter.description}</Form.Label>
        <Form.Select value={values[0] ?? ''}  onChange={handleSelectChange} aria-label="" style={{overflow: 'auto', maxHeight: '450px'}}>
        <option value="" disabled>
            {t("dashboard:filters.selectDafaultTag", {
                filter: filter.description
            })}
        </option>
        {filter.values?.map((value, index) => (
          <option value={value.key as string} key={index}>
            {value.value as string}
          </option>
        ))}
      </Form.Select>
    </Form.Group >
  );
}